module.exports = __webpack_public_path__ + "static/media/Bank (26).60351cdd.svg";